import { render } from "./PopapView.vue?vue&type=template&id=a0e25858&scoped=true"
import script from "./PopapView.vue?vue&type=script&lang=js"
export * from "./PopapView.vue?vue&type=script&lang=js"

import "./PopapView.vue?vue&type=style&index=0&id=a0e25858&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e25858"]])

export default __exports__